import p from './privacy-policy.html'
import t from './terms-of-use.html'

export default {
  'privacy-policy': p,
  'terms-of-use': t
}
